import { useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  catalogPagePath,
  chainScope,
  storeScope,
  type CatalogScope,
} from "../api/catalogScope";
import type { ChainId, StoreId } from "@KassaroAB/shared/types/ids";

export const useCatalogScope = (collection?: string, itemId?: string) => {
  const { storeId, chainId } = useParams<{
    storeId: StoreId;
    chainId: ChainId;
  }>();

  const scope = useMemo<CatalogScope | null>(() => {
    if (storeId) {
      return storeScope(storeId);
    }
    if (chainId) {
      return chainScope(chainId);
    }
    return null;
  }, [storeId, chainId]);

  const catalogPath = (pathCollection: string, pathItemId?: string) =>
    scope ? catalogPagePath(scope, pathCollection, pathItemId) : "";

  return {
    scope,
    storeId: storeId ?? null,
    chainId: chainId ?? null,
    pagePath: collection ? catalogPath(collection, itemId) : "",
    catalogPath,
  };
};
